import { render, staticRenderFns } from "./CancellationPolicies.vue?vue&type=template&id=3a7d680b&scoped=true"
import script from "./CancellationPolicies.vue?vue&type=script&lang=js"
export * from "./CancellationPolicies.vue?vue&type=script&lang=js"
import style0 from "./CancellationPolicies.vue?vue&type=style&index=0&id=3a7d680b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d680b",
  null
  
)

export default component.exports